// extracted by mini-css-extract-plugin
export var main = "index-module--main--pU-FT";
export var fadein = "index-module--fadein--n+sJD";